import { FC, Fragment, useState } from 'react';
import { RadioCheckIcon, RadioOutlineIcon, TrashIcon } from '@/icons';

import { AddressUserDetails } from '@/models/user-details';

import Text from '../Text';
import Svg from '../Svg';
import Button from '../Button';
import Heading from '../Heading';
import Modal from '@/layouts/Modal';
import DeleteAddress from '@/features/Account/components/DeleteAddress';
import CustomerAddressForm from '../Forms/CustomerAddressForm';
import { twMerge } from 'tailwind-merge';

// enum ADDRESS_OPERATION_TYPES {
//   EDIT_ADDRESS = 'edit_address',
//   DELETE_ADDRESS = 'delete_address',
// }

type BaseAddressPropTypes = {
  address: AddressUserDetails;
};

type CheckoutAddressPropTypes = BaseAddressPropTypes & {
  layout: 'Checkout';
  checked: boolean;
  isNotServiceable: boolean;
  type?: string;
};

type AccountAddressPropTypes = BaseAddressPropTypes & {
  layout: 'Account';
};

type LocationAddressPropTypes = BaseAddressPropTypes & {
  layout: 'Location';
  checked: boolean;
};

type AddressCardPropTypes =
  | CheckoutAddressPropTypes
  | AccountAddressPropTypes
  | LocationAddressPropTypes;

// const AddressDropdownMenu: FC<{
//   handleAddressMenuItem: (key: ADDRESS_OPERATION_TYPES) => void;
// }> = ({ handleAddressMenuItem }) => {
//   return (
//     <Menu as='div' className='relative inline-block text-left'>
//       <Menu.Button className='border-none bg-inherit outline-hidden'>
//         <Svg aria-hidden='true' className='stroke-none' fill='none'>
//           <VerticalDotsIcon />
//         </Svg>
//       </Menu.Button>
//       <Menu.Items className='absolute right-0 z-10 my-2 w-56 origin-top-right rounded-md border border-black/20 bg-white p-2 shadow-lg'>
//         {[
//           ADDRESS_ACTION_TYPES.editAddress,
//           ADDRESS_ACTION_TYPES.deleteAddress,
//         ].map((el: any) => (
//           <Menu.Item
//             key={el?.key}
//             as='button'
//             className='block w-full p-2 text-left text-sm text-black hover:text-fig'
//             onClick={() => handleAddressMenuItem(el.key)}>
//             {el?.label}
//           </Menu.Item>
//         ))}
//       </Menu.Items>
//     </Menu>
//   );
// };
const AddressCard: FC<AddressCardPropTypes> = props => {
  const { layout, address } = props;
  const isNotServiceable =
    'layout' in props && 'isNotServiceable' in props
      ? props.isNotServiceable
      : false;
  const type = 'type' in props ? props.type : null;
  const [addressToDelete, setAddressToDelete] = useState<number>();
  const [addressToEdit, setAddressToEdit] = useState<AddressUserDetails>();

  function handleDeleteAddress(id: number) {
    setAddressToDelete(id);
  }

  function handleEditAddress(address: AddressUserDetails) {
    setAddressToEdit(address);
  }

  // const handleAddressMenuItem = (key: ADDRESS_OPERATION_TYPES) => {
  //   if (key === ADDRESS_OPERATION_TYPES.EDIT_ADDRESS) {
  //     handleEditAddress(address);
  //   } else {
  //     handleDeleteAddress(address.id);
  //   }
  // };

  return (
    <Fragment>
      <div
        className={twMerge(
          'base-radio-group flex w-full flex-row items-start justify-between',
          layout !== 'Checkout' && 'base-radio-group'
        )}>
        {layout === 'Checkout' && (
          <div className='mt-1 md:mt-[0.40rem]' aria-label='icon'>
            {props?.checked ? (
              <Svg
                fill='none'
                viewBox='0 0 18 16'
                className='h-4 w-4 stroke-fig stroke-1'>
                <RadioCheckIcon />
              </Svg>
            ) : (
              <Svg
                fill='none'
                viewBox='0 0 18 16'
                className='h-4 w-4 stroke-black'>
                <RadioOutlineIcon />
              </Svg>
            )}
          </div>
        )}
        <div aria-label='address' className='w-full flex-1'>
          <div className='flex items-center justify-between'>
            <Heading as='h4' className='text-base'>
              {address?.firstname} {address?.lastname}
            </Heading>
            {
              layout === 'Account' ? (
                <button onClick={() => handleDeleteAddress(address.id)}>
                  <Svg className='cursor-pointer hover:stroke-fig h-6 w-6'>
                    <TrashIcon />
                  </Svg>
                </button>
              ) : layout === 'Checkout' ? null : null // /> //   handleAddressMenuItem={handleAddressMenuItem} // <AddressDropdownMenu
            }
          </div>
          <div>
            <Text className='text-sm text-black'>{address?.street[1]},</Text>
            <Text className='text-sm text-black'>{address?.street[0]},</Text>
            <Text className='text-sm text-black'>
              {address?.city}, {address?.region.region}
            </Text>
            <Text className='text-sm text-black'>{address?.postcode}</Text>
            <Text className='text-sm text-black'>{address?.telephone}</Text>
            {type === 'Shipping' && isNotServiceable && (
              <Text className='text-xs font-medium text-[#D48A7A]'>
                Unfortunately we can't deliver your order to this area at the
                moment.{' '}
              </Text>
            )}
          </div>
          {layout !== 'Checkout' && layout !== 'Location' && (
            <Button
              label='Edit Address'
              className='mt-2 w-36'
              variant='secondary'
              onClick={() => handleEditAddress(address)}
            />
          )}
        </div>
      </div>
      <Modal
        show={!!addressToDelete}
        onClose={() => setAddressToDelete(undefined)}
        id='delete-address'
        title='Delete Address'>
        <DeleteAddress
          id={addressToDelete}
          onClose={() => setAddressToDelete(undefined)}
        />
      </Modal>
      <Modal
        show={!!addressToEdit}
        onClose={() => setAddressToEdit(undefined)}
        id='edit-address'
        title='Edit Address'>
        <CustomerAddressForm
          address={addressToEdit}
          onClose={() => setAddressToEdit(undefined)}
        />
      </Modal>
    </Fragment>
  );
};

export default AddressCard;
